var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgililidadditopay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_5",
    x: 0,
    y: 0,
    width: 196,
    height: 196,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agililidad_dito_pay",
    "data-name": "Agililidad dito pay",
    transform: "translate(-703 -1787)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 703, 1787)",
    filter: "url(#Elipse_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5-2",
    "data-name": "Elipse 5",
    cx: 89,
    cy: 89,
    r: 89,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Phone_camera_focus-WF",
    "data-name": "Phone camera focus-WF",
    transform: "translate(741.285 1833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M74.819,80.943,59.865,82.009l1.211,13,15.031-1.284Zm2.756-3.279,1.9,18.854L58.3,98.328,56.512,79.167ZM43.315,62.2a2.756,2.756,0,1,1-1.952.8,2.747,2.747,0,0,1,1.952-.8ZM36.239,35.612h1.536v2.4H40.2v1.536H36.239Zm6.308-6.191h1.536v2.326h2.348v1.536H44.084v2.326H42.547V33.283H40.2V31.747h2.348Zm22.046-.528V49.986l.017-.013a14.387,14.387,0,0,0,3.931-5.34,12.652,12.652,0,0,0-2.01-14q-.7-.592-1.355-1.191ZM46.428,25.482h3.961v3.939H48.852v-2.4H46.428Zm-10.189,0H40.2v1.536H37.775v2.406H36.239ZM0,24.609H3.073v6.155H9.224v3.073H0Zm64.594-5.431v5.207l.152.191a33.258,33.258,0,0,0,3.959,3.9c6.253,7.4,3.958,15.182,2.56,17.576-4.889,10.6-13.3,8.852-13.661,8.772l-1.22-.273L56.4,53.3c.191-13.474-2.624-16.675-3.841-17.425a2.3,2.3,0,0,0-1.4-.356l1.672,20.753,1.057,7.909,4.692,8.075,16.65-1.088C77.814,60.807,81.471,46,81.63,44.943c.57-12.582-12.263-22.5-16.8-25.6ZM12.3,13.842h3.073v4.615h4.618V21.53H15.376v4.615H12.3V21.53H7.688V18.458H12.3ZM0,6.155H9.224V9.227H3.073v6.151H0Zm36.912,0h12.3V9.224h-12.3ZM26.145,3.073A1.543,1.543,0,0,0,24.6,4.612v64.6a1.543,1.543,0,0,0,1.543,1.539h28.07l-3.326-5.856L49.777,56.6,48.4,39.551H46.428V38.015h1.853l-.36-4.468.854-.479a5.482,5.482,0,0,1,5.316.144c3.567,2.12,5.38,8.413,5.392,18.709a7.735,7.735,0,0,0,1.857-.263l.18-.055V4.612a1.54,1.54,0,0,0-1.539-1.539Zm0-3.073H59.981a4.616,4.616,0,0,1,4.612,4.612V15.566l.1.041a1.559,1.559,0,0,1,.139.072c.842.5,20.633,12.383,19.862,29.51-.034.765-3.69,15.548-6.754,27.817l-.27,1.088L56.881,75.449l-.923-1.625H26.145a4.619,4.619,0,0,1-4.615-4.612V4.612A4.619,4.619,0,0,1,26.145,0Z",
    transform: "translate(17.715)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgililidadditopay);
export default __webpack_public_path__ + "static/media/Agililidad dito pay.c9896af9f87d5cade21df42775cf993d.svg";
export { ForwardRef as ReactComponent };